import CoinsSm from '../../assets/images/purchases/coins-purchase-sm.png';
import CoinsMd from '../../assets/images/purchases/coins-purchase-md.png';
import CoinsLg from '../../assets/images/purchases/coins-purchase-lg.png';
import CoinsXl from '../../assets/images/purchases/coins-purchase-xl.png';
import EnergySm from '../../assets/images/purchases/energy-purchase-sm.png';
import EnergyMd from '../../assets/images/purchases/energy-purchase-md.png';
import EnergyLg from '../../assets/images/purchases/energy-purchase-lg.png';
import EnergyXl from '../../assets/images/purchases/energy-purchase-xl.png';
import EnergyCoinsPackageSm from '../../assets/images/purchases/energy-coins-package-sm.png';
import EnergyCoinsPackageMd from '../../assets/images/purchases/energy-coins-package-md.png';
import EnergyCoinsPackageLg from '../../assets/images/purchases/energy-coins-package-lg.png';
import EnergyCoinsPackageXl from '../../assets/images/purchases/energy-coins-package-xl.png';

const getPurchasableStoreItemIcon = (icon: string) => {
  switch (icon) {
    case 'coins-sm-pack':
      return <img src={CoinsSm} alt={icon} className="h-full" />;
    case 'coins-md-pack':
      return <img src={CoinsMd} alt={icon} className="h-full" />;
    case 'coins-lg-pack':
      return <img src={CoinsLg} alt={icon} className="h-full" />;
    case 'coins-xl-pack':
      return <img src={CoinsXl} alt={icon} className="h-full" />;
    case 'energy-sm-pack':
      return <img src={EnergySm} alt={icon} className="h-full" />;
    case 'energy-md-pack':
      return <img src={EnergyMd} alt={icon} className="h-full" />;
    case 'energy-lg-pack':
      return <img src={EnergyLg} alt={icon} className="h-full" />;
    case 'energy-xl-pack':
      return <img src={EnergyXl} alt={icon} className="h-full" />;
    case 'sm-package':
      return <img src={EnergyCoinsPackageSm} alt={icon} className="h-full" />;
    case 'md-package':
      return <img src={EnergyCoinsPackageMd} alt={icon} className="h-full" />;
    case 'lg-package':
      return <img src={EnergyCoinsPackageLg} alt={icon} className="h-full" />;
    case 'xl-package':
      return <img src={EnergyCoinsPackageXl} alt={icon} className="h-full" />;
    default:
      return null;
  }
};

export default getPurchasableStoreItemIcon;
